/* Attribuzione marketing first-touch: il primo arrivo non viene mai sovrascritto
   dalle visite successive. Nessuna PII: solo pagine, referrer e parametri UTM. */

const KEY = "flash_attr_v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const readUtms = () => {
  const p = new URLSearchParams(window.location.search);
  return Object.fromEntries(UTM_KEYS.filter((k) => p.get(k)).map((k) => [k, p.get(k)]));
};

export const captureAttribution = () => {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch: mai sovrascrivere
    const utms = readUtms();
    localStorage.setItem(KEY, JSON.stringify({
      firstTouchTimestamp: new Date().toISOString(),
      firstTouchPage: window.location.pathname,
      landingPage: window.location.pathname,
      referrer: document.referrer || "",
      utms,
    }));
  } catch { /* storage non disponibile */ }
};

export const getAttribution = () => {
  let first = null;
  try { first = JSON.parse(localStorage.getItem(KEY) || "null"); } catch { /* ignore */ }
  const current = readUtms();
  return {
    // UTM: first-touch se presenti, altrimenti quelli della visita corrente
    ...(first?.utms && Object.keys(first.utms).length ? first.utms : current),
    ...(first?.landingPage ? { landingPage: first.landingPage } : {}),
    ...(first?.firstTouchPage ? { firstTouchPage: first.firstTouchPage } : {}),
    ...(first?.firstTouchTimestamp ? { firstTouchTimestamp: first.firstTouchTimestamp } : {}),
    referrer: first?.referrer || document.referrer || "",
    lastTouchPage: window.location.pathname,
  };
};
